<template>
  <div>
    <v-container fluid>

      <v-row>

        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              Datas produits
              <v-spacer/>
              <div>
                <v-select flat
                          filled
                          rounded
                          label="Régions"
                          hint="Filtrer par régions"
                          persistent-hint
                          dense
                          item-value="name"
                          multiple
                          chips
                          deletable-chips
                          small-chips
                          item-text="name"
                          prepend-inner-icon="mdi-map-marker"
                          v-model="regions_1"
                          :items="filter_elements.regions"
                >
                  <template v-slot:append-outer>
                    <v-btn
                        fab
                        depressed
                        color="primary"
                        small
                        style="margin-top: -8px"
                        @click.stop="getDataProduct"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn text
                           fab
                           depressed
                           color="primary"
                           small
                           style="margin-top: -8px"
                           @click.stop="getDataProduct"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </div>
              <v-spacer/>
              <v-btn icon color="info" class="v-btn--active" @click="show1 = !show1">
                <v-icon v-if="!show1">mdi-plus-circle</v-icon>
                <v-icon v-else>mdi-minus-circle</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider v-if="show1"/>

            <v-card-text v-if="show1">

              <v-row v-if="isLoading1">
                <v-col cols="12" lg="3" v-for="item in 5" :key="item">
                  <v-card outlined rounded flat>
                    <v-skeleton-loader type="article"/>
                  </v-card>
                </v-col>
              </v-row>

              <div v-else>
                <h4 class="mb-5 d-flex align-center">
                  <v-icon size="15" left color="info">mdi-circle</v-icon>
                  Nombre de produits scannés
                </h4>
                <v-row>
                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Aujourd'hui</div>
                        <v-spacer/>
                        <v-avatar color="indigo" size="38">
                          <v-icon dark>mdi-calendar-today</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 indigo--text">
                          Unique (POS solo ou POS et Conso) :
                          <small class="indigo--text text--lighten-1">{{ data_product.today.unique || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          POS (Solo) :
                          <small class="indigo--text text--lighten-1">{{ data_product.today.pos_solo || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          Duo :
                          <small class="indigo--text text--lighten-1">{{ data_product.today.duo || 0 }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Cette semaine</div>
                        <v-spacer/>
                        <v-avatar color="green" size="38">
                          <v-icon dark>mdi-calendar-week</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 green--text">
                          Unique (POS solo ou POS et Conso) :
                          <small class="green--text text--lighten-1">{{ data_product.week.unique || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          POS (Solo) :
                          <small class="green--text text--lighten-1">{{ data_product.week.pos_solo || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Duo :
                          <small class="green--text text--lighten-1">{{ data_product.week.duo || 0 }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Ce mois</div>
                        <v-spacer/>
                        <v-avatar color="blue" size="38">
                          <v-icon dark>mdi-calendar-month</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 blue--text">
                          Unique (POS solo ou POS et Conso) :
                          <small class="blue--text text--lighten-1">{{ data_product.month.unique || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          POS (Solo) :
                          <small class="blue--text text--lighten-1">{{ data_product.month.pos_solo || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Duo :
                          <small class="blue--text text--lighten-1">{{ data_product.month.duo || 0 }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Depuis le 15/05/2025</div>
                        <v-spacer/>
                        <v-avatar color="purple" size="38">
                          <v-icon dark>mdi-calendar-range</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 purple--text">
                          Unique (POS solo ou POS et Conso) :
                          <small class="purple--text text--lighten-1">{{ data_product.date.unique || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          POS (Solo) :
                          <small class="purple--text text--lighten-1">{{ data_product.date.pos_solo || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Duo :
                          <small class="purple--text text--lighten-1">{{ data_product.date.duo || 0 }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Performance</div>
                        <v-spacer/>
                        <v-avatar color="teal" size="38">
                          <v-icon dark>mdi-chart-line</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 teal--text">
                          Moy. code unique / POS :
                          <small class="teal--text text--lighten-1">{{
                              data_product.performance.code_unique_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 teal--text">
                          Moy. code duo / POS :
                          <small class="teal--text text--lighten-1">{{
                              data_product.performance.code_duo_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                </v-row>
              </div>

            </v-card-text>

          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              Datas POS
              <v-spacer/>
              <div>
                <v-select flat
                          filled
                          rounded
                          label="Régions"
                          hint="Filtrer par régions"
                          persistent-hint
                          dense
                          item-value="name"
                          multiple
                          chips
                          deletable-chips
                          small-chips
                          item-text="name"
                          prepend-inner-icon="mdi-map-marker"
                          v-model="regions_2"
                          :items="filter_elements.regions"
                >
                  <template v-slot:append-outer>
                    <v-btn
                        fab
                        depressed
                        color="primary"
                        small
                        style="margin-top: -8px"
                        @click.stop="getDataPos"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn text
                           fab
                           depressed
                           color="primary"
                           small
                           style="margin-top: -8px"
                           @click.stop="getDataPos"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </div>
              <v-spacer/>
              <v-btn icon color="info" class="v-btn--active" @click="show2 = !show2">
                <v-icon v-if="!show2">mdi-plus-circle</v-icon>
                <v-icon v-else>mdi-minus-circle</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider v-if="show2"/>

            <v-card-text v-if="show2">

              <v-row v-if="isLoading2">
                <v-col cols="12" lg="3" v-for="item in 4" :key="item">
                  <v-card outlined rounded flat>
                    <v-skeleton-loader type="article"/>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card outlined rounded flat>
                    <v-skeleton-loader type="table"/>
                  </v-card>
                </v-col>
              </v-row>

              <div v-else>

                <h4 class="mb-5 d-flex align-center">
                  <v-icon size="15" left color="info">mdi-circle</v-icon>
                  Fréquence d’activités des POS (Moyenne de codes)
                </h4>

                <v-row>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Aujourd'hui</div>
                        <v-spacer/>
                        <v-avatar color="indigo" size="38">
                          <v-icon dark>mdi-calendar-today</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 indigo--text">
                          Codes / POS :
                          <small class="indigo--text text--lighten-1">{{
                              data_pos.today.avg_codes_per_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          Solo / POS :
                          <small class="indigo--text text--lighten-1">{{
                              data_pos.today.avg_codes_solo_per_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          Duo / POS :
                          <small class="indigo--text text--lighten-1">{{
                              data_pos.today.avg_codes_duo_per_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Cette semaine</div>
                        <v-spacer/>
                        <v-avatar color="green" size="38">
                          <v-icon dark>mdi-calendar-week</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 green--text">
                          Codes / POS :
                          <small class="green--text text--lighten-1">{{ data_pos.week.avg_codes_per_pos || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Solo / POS :
                          <small class="green--text text--lighten-1">{{
                              data_pos.week.avg_codes_solo_per_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Duo / POS :
                          <small class="green--text text--lighten-1">{{
                              data_pos.week.avg_codes_duo_per_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Ce mois</div>
                        <v-spacer/>
                        <v-avatar color="blue" size="38">
                          <v-icon dark>mdi-calendar-month</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 blue--text">
                          Codes / POS :
                          <small class="blue--text text--lighten-1">{{ data_pos.month.avg_codes_per_pos || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Solo / POS :
                          <small class="blue--text text--lighten-1">{{
                              data_pos.month.avg_codes_solo_per_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Duo / POS :
                          <small class="blue--text text--lighten-1">{{
                              data_pos.month.avg_codes_duo_per_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Depuis le 15/05/2025</div>
                        <v-spacer/>
                        <v-avatar color="purple" size="38">
                          <v-icon dark>mdi-calendar-range</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 purple--text">
                          Codes / POS :
                          <small class="purple--text text--lighten-1">{{ data_pos.date.avg_codes_per_pos || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Solo / POS :
                          <small class="purple--text text--lighten-1">{{
                              data_pos.date.avg_codes_solo_per_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Duo / POS :
                          <small class="purple--text text--lighten-1">{{
                              data_pos.date.avg_codes_duo_per_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <h4 class="my-5 d-flex align-center">
                  <v-icon size="15" left color="info" class="me-2">mdi-circle</v-icon>
                  Progression des POS (nouveaux vs récurrents)
                </h4>

                <v-row>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Aujourd'hui</div>
                        <v-spacer/>
                        <v-avatar color="indigo" size="38">
                          <v-icon dark>mdi-calendar-today</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 indigo--text">
                          POS nouveaux :
                          <small class="indigo--text text--lighten-1">{{
                              data_pos.today.progression.new_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          POS récurrents :
                          <small class="indigo--text text--lighten-1">{{
                              data_pos.today.progression.recurring_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Cette semaine</div>
                        <v-spacer/>
                        <v-avatar color="green" size="38">
                          <v-icon dark>mdi-calendar-week</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 green--text">
                          POS nouveaux :
                          <small class="green--text text--lighten-1">{{
                              data_pos.week.progression.new_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          POS récurrents :
                          <small class="green--text text--lighten-1">{{
                              data_pos.week.progression.recurring_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Ce mois</div>
                        <v-spacer/>
                        <v-avatar color="blue" size="38">
                          <v-icon dark>mdi-calendar-month</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 blue--text">
                          POS nouveaux :
                          <small class="blue--text text--lighten-1">{{
                              data_pos.month.progression.new_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          POS récurrents :
                          <small class="blue--text text--lighten-1">{{
                              data_pos.month.progression.recurring_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Depuis le 15/05/2025</div>
                        <v-spacer/>
                        <v-avatar color="purple" size="38">
                          <v-icon dark>mdi-calendar-range</v-icon>
                        </v-avatar>
                      </v-card-title>
                      <v-card-text>
                        <h4 class="mb-2 purple--text">
                          POS nouveaux :
                          <small class="purple--text text--lighten-1">{{
                              data_pos.date.progression.new_pos || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          POS récurrents :
                          <small class="purple--text text--lighten-1">{{
                              data_pos.date.progression.recurring_pos || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>


                <h4 class="my-5 d-flex align-center">
                  <v-icon size="15" left color="info" class="me-2">mdi-circle</v-icon>
                  Daily performance POS
                </h4>

                <v-row>
                  <v-col>
                    <v-card outlined rounded>
                      <v-card-text class="pa-0">
                        <v-data-table
                            :headers="headers1"
                            :items="data_pos.daily_performance"
                        >
                        </v-data-table>
                      </v-card-text>
                    </v-card>

                  </v-col>
                </v-row>
              </div>

            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              Datas consommateurs
              <v-spacer/>
              <div>
                <v-select flat
                          filled
                          rounded
                          label="Régions"
                          hint="Filtrer par régions"
                          persistent-hint
                          dense
                          item-value="name"
                          multiple
                          chips
                          deletable-chips
                          small-chips
                          item-text="name"
                          prepend-inner-icon="mdi-map-marker"
                          v-model="regions_3"
                          :items="filter_elements.regions"
                >
                  <template v-slot:append-outer>
                    <v-btn
                        fab
                        depressed
                        color="primary"
                        small
                        style="margin-top: -8px"
                        @click.stop="getDataConsumer"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn text
                           fab
                           depressed
                           color="primary"
                           small
                           style="margin-top: -8px"
                           @click.stop="getDataConsumer"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </div>
              <v-spacer/>
              <v-btn icon color="info" class="v-btn--active" @click="show3 = !show3">
                <v-icon v-if="!show3">mdi-plus-circle</v-icon>
                <v-icon v-else>mdi-minus-circle</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider v-if="show3"/>

            <v-card-text v-if="show3">

              <v-row v-if="isLoading3">
                <v-col cols="12">
                  <v-card outlined rounded flat>
                    <v-skeleton-loader type="table"/>
                  </v-card>
                </v-col>
                <v-col cols="12" lg="3" v-for="item in 4" :key="item">
                  <v-card outlined rounded flat>
                    <v-skeleton-loader type="article"/>
                  </v-card>
                </v-col>
              </v-row>

              <div v-else>
                <h4 class="mb-5 d-flex align-center">
                  <v-icon size="15" left color="info">mdi-circle</v-icon>
                  Consommateurs
                </h4>

                <v-row>
                  <v-col>
                    <v-card outlined rounded>
                      <v-card-text class="pa-0">
                        <v-data-table
                            :headers="headers2"
                            :items="data_consumer.consumers"
                        >
                        </v-data-table>
                      </v-card-text>
                    </v-card>

                  </v-col>
                </v-row>
                <h4 class="my-5 d-flex align-center">
                  <v-icon size="15" left color="info">mdi-circle</v-icon>
                  Fréquence d’activité des consommateurs
                </h4>

                <v-row>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Aujourd'hui</div>
                        <v-spacer/>
                        <v-avatar color="deep-purple" size="38">
                          <v-icon dark>mdi-account-group</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 deep-purple--text">
                          Moy. codes/conso :
                          <small
                              class="deep-purple--text text--lighten-1">{{
                              data_consumer.today.frequency.average_codes_per_user || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 deep-purple--text">
                          Conso (1 code) :
                          <small
                              class="deep-purple--text text--lighten-1">{{
                              data_consumer.today.frequency.users_with_1_code || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 deep-purple--text">
                          Conso (2 codes) :
                          <small
                              class="deep-purple--text text--lighten-1">{{
                              data_consumer.today.frequency.users_with_2_codes || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 deep-purple--text">
                          Conso (> 2 codes) :
                          <small
                              class="deep-purple--text text--lighten-1">{{
                              data_consumer.today.frequency.users_with_more_2 || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Cette semaine</div>
                        <v-spacer/>
                        <v-avatar color="green" size="38">
                          <v-icon dark>mdi-calendar-week</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 green--text">
                          Moy. codes/conso :
                          <small
                              class="green--text text--lighten-1">{{
                              data_consumer.week.frequency.average_codes_per_user || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Conso (1 code) :
                          <small
                              class="green--text text--lighten-1">{{
                              data_consumer.week.frequency.users_with_1_code || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Conso (2 codes) :
                          <small
                              class="green--text text--lighten-1">{{
                              data_consumer.week.frequency.users_with_2_codes || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Conso (> 2 codes) :
                          <small
                              class="green--text text--lighten-1">{{
                              data_consumer.week.frequency.users_with_more_2 || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Ce mois</div>
                        <v-spacer/>
                        <v-avatar color="blue" size="38">
                          <v-icon dark>mdi-calendar-month</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 blue--text">
                          Moy. codes/conso :
                          <small
                              class="blue--text text--lighten-1">{{
                              data_consumer.month.frequency.average_codes_per_user || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Conso (1 code) :
                          <small
                              class="blue--text text--lighten-1">{{
                              data_consumer.month.frequency.users_with_1_code || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Conso (2 codes) :
                          <small
                              class="blue--text text--lighten-1">{{
                              data_consumer.month.frequency.users_with_2_codes || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Conso (> 2 codes) :
                          <small
                              class="blue--text text--lighten-1">{{
                              data_consumer.month.frequency.users_with_more_2 || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>


                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Depuis le 15/05/2025</div>
                        <v-spacer/>
                        <v-avatar color="purple" size="38">
                          <v-icon dark>mdi-calendar-range</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 purple--text">
                          Moy. codes/conso :
                          <small
                              class="purple--text text--lighten-1">{{
                              data_consumer.date.frequency.average_codes_per_user || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Conso (1 code) :
                          <small
                              class="purple--text text--lighten-1">{{
                              data_consumer.date.frequency.users_with_1_code || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Conso (2 codes) :
                          <small
                              class="purple--text text--lighten-1">{{
                              data_consumer.date.frequency.users_with_2_codes || 0
                            }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Conso (> 2 codes) :
                          <small
                              class="purple--text text--lighten-1">{{
                              data_consumer.date.frequency.users_with_more_2 || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <h4 class="my-5 d-flex align-center">
                  <v-icon size="15" left color="info">mdi-circle</v-icon>
                  Progression des consommateurs (nouveaux vs réachat)
                </h4>

                <v-row>
                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Aujourd'hui</div>
                        <v-spacer/>
                        <v-avatar color="indigo" size="38">
                          <v-icon dark>mdi-account-plus</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 indigo--text">
                          Conso nouveaux :
                          <small
                              class="indigo--text text--lighten-1">{{
                              data_consumer.today.progression.new_clients || 0
                            }}</small>
                        </h4>

                        <h4 class="mb-2 indigo--text">
                          Conso réachat :
                          <small
                              class="indigo--text text--lighten-1">{{
                              data_consumer.today.progression.repeat_clients || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Cette semaine</div>
                        <v-spacer/>
                        <v-avatar color="green" size="38">
                          <v-icon dark>mdi-calendar-week</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 green--text">
                          Conso nouveaux :
                          <small
                              class="green--text text--lighten-1">{{
                              data_consumer.week.progression.new_clients || 0
                            }}</small>
                        </h4>

                        <h4 class="mb-2 green--text">
                          Conso réachat :
                          <small
                              class="green--text text--lighten-1">{{
                              data_consumer.week.progression.repeat_clients || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Ce mois</div>
                        <v-spacer/>
                        <v-avatar color="blue" size="38">
                          <v-icon dark>mdi-calendar-month</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 blue--text">
                          Conso nouveaux :
                          <small
                              class="blue--text text--lighten-1">{{
                              data_consumer.month.progression.new_clients || 0
                            }}</small>
                        </h4>

                        <h4 class="mb-2 blue--text">
                          Conso réachat :
                          <small
                              class="blue--text text--lighten-1">{{
                              data_consumer.month.progression.repeat_clients || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Depuis le 15/05/2025</div>
                        <v-spacer/>
                        <v-avatar color="purple" size="38">
                          <v-icon dark>mdi-calendar-range</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 purple--text">
                          Conso nouveaux :
                          <small
                              class="purple--text text--lighten-1">{{
                              data_consumer.date.progression.new_clients || 0
                            }}</small>
                        </h4>

                        <h4 class="mb-2 purple--text">
                          Conso réachat :
                          <small
                              class="purple--text text--lighten-1">{{
                              data_consumer.date.progression.repeat_clients || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              Datas financieres
              <v-spacer/>
              <div>
                <v-select flat
                          filled
                          rounded
                          label="Régions"
                          hint="Filtrer par régions"
                          persistent-hint
                          dense
                          item-value="name"
                          multiple
                          chips
                          deletable-chips
                          small-chips
                          item-text="name"
                          prepend-inner-icon="mdi-map-marker"
                          v-model="regions_4"
                          :items="filter_elements.regions"
                >
                  <template v-slot:append-outer>
                    <v-btn
                        fab
                        depressed
                        color="primary"
                        small
                        style="margin-top: -8px"
                        @click.stop="getDataFinancial"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn text
                           fab
                           depressed
                           color="primary"
                           small
                           style="margin-top: -8px"
                           @click.stop="getDataFinancial"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </div>
              <v-spacer/>
              <v-btn icon color="info" class="v-btn--active" @click="show4 = !show4">
                <v-icon v-if="!show4">mdi-plus-circle</v-icon>
                <v-icon v-else>mdi-minus-circle</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider v-if="show4"/>

            <v-card-text v-if="show4">

              <v-row v-if="isLoading4">
                <v-col cols="12" lg="3" v-for="item in 4" :key="item">
                  <v-card outlined rounded flat>
                    <v-skeleton-loader type="article"/>
                  </v-card>
                </v-col>
              </v-row>

              <div v-else>
                <h4 class="my-5 d-flex align-center">
                  <v-icon size="15" left color="info">mdi-circle</v-icon>
                  Points POS (40 pts / 80 pts / total)
                </h4>

                <v-row>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Aujourd'hui</div>
                        <v-spacer/>
                        <v-avatar color="indigo" size="38">
                          <v-icon dark>mdi-calendar</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 indigo--text">
                          POS (40 pts) :
                          <small class="indigo--text text--lighten-1">{{ data_financial.today.points_40 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          POS (80 pts) :
                          <small class="indigo--text text--lighten-1">{{ data_financial.today.points_80 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 indigo--text">
                          Total des points :
                          <small
                              class="indigo--text text--lighten-1">{{
                              priceFormat(data_financial.today.total_points) || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Cette semaine</div>
                        <v-spacer/>
                        <v-avatar color="green" size="38">
                          <v-icon dark>mdi-calendar-week</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 green--text">
                          POS (40 pts) :
                          <small class="green--text text--lighten-1">{{ data_financial.week.points_40 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          POS (80 pts) :
                          <small class="green--text text--lighten-1">{{ data_financial.week.points_80 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 green--text">
                          Total des points :
                          <small class="green--text text--lighten-1">{{
                              priceFormat(data_financial.week.total_points) || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Ce mois</div>
                        <v-spacer/>
                        <v-avatar color="blue" size="38">
                          <v-icon dark>mdi-calendar-month</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 blue--text">
                          POS (40 pts) :
                          <small class="blue--text text--lighten-1">{{ data_financial.month.points_40 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          POS (80 pts) :
                          <small class="blue--text text--lighten-1">{{ data_financial.month.points_80 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 blue--text">
                          Total des points :
                          <small class="blue--text text--lighten-1">{{
                              priceFormat(data_financial.month.total_points) || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Depuis le 15/05/2025</div>
                        <v-spacer/>
                        <v-avatar color="purple" size="38">
                          <v-icon dark>mdi-calendar-range</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 purple--text">
                          POS (40 pts) :
                          <small class="purple--text text--lighten-1">{{ data_financial.date.points_40 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          POS (80 pts) :
                          <small class="purple--text text--lighten-1">{{ data_financial.date.points_80 || 0 }}</small>
                        </h4>
                        <h4 class="mb-2 purple--text">
                          Total des points :
                          <small
                              class="purple--text text--lighten-1">{{
                              priceFormat(data_financial.date.total_points) || 0
                            }}</small>
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-card outlined rounded flat>
                      <v-card-title class="text-no-wrap">
                        <div class="fs-15 font-weight-bold">Total des points</div>
                        <v-spacer/>
                        <v-avatar color="red" size="38">
                          <v-icon dark>mdi-counter</v-icon>
                        </v-avatar>
                      </v-card-title>

                      <v-card-text>
                        <h4 class="mb-2 red--text">
                          Total actuel :
                          <small class="red--text text--lighten-1">{{ priceFormat(data_financial.total) || 0 }}</small>
                        </h4>

                        <h4 class="mb-2 grey--text font-italic">
                          Plafond autorisé :
                          <small class="grey--text text--lighten-1 font-italic">{{ priceFormat(100000) }}</small>
                        </h4>

                        <v-progress-linear
                            :value="Math.min(((data_financial.total || 0) / 100000) * 100, 100)"
                            height="12"
                            color="red"
                            rounded
                            striped
                            stream
                        >
                          <template v-slot:default="{ value }">
                            <small class="white--text">{{ value }}%</small>
                          </template>
                        </v-progress-linear>
                      </v-card-text>
                    </v-card>
                  </v-col>


                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>


    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      regions_1: [],
      regions_2: [],
      regions_3: [],
      regions_4: [],

      show1: true,
      show2: true,
      show3: true,
      show4: true,

      data_product: {
        today: {},
        week: {},
        month: {},
        date: {},
        performance: {},
      },

      data_pos: {
        today: {
          progression: {}
        },
        week: {
          progression: {}
        },
        month: {
          progression: {}
        },
        date: {
          progression: {}
        },
        daily_performance: [],
      },

      data_consumer: {
        today: {
          frequency: {},
          progression: {},
        },
        week: {
          frequency: {},
          progression: {},
        },
        month: {
          frequency: {},
          progression: {},
        },
        date: {
          frequency: {},
          progression: {},
        },
        consumers: [],
      },

      data_financial: {
        today: {},
        week: {},
        month: {},
        date: {},
        total: 0,
      },

      isLoading1: false,
      isLoading2: false,
      isLoading3: false,
      isLoading4: false,

      headers1: [
        {text: 'Date', value: 'date'},
        {text: 'POS Total', value: 'pos_total'},
        {text: 'POS Solo', value: 'pos_solo'},
        {text: 'POS Duo', value: 'pos_duo'},
        {text: 'Codes Total', value: 'codes_total'},
        {text: 'Codes Solo', value: 'codes_solo'},
        {text: 'Codes Duo', value: 'codes_duo'},
      ],

      headers2: [
        {text: 'Date', value: 'date'},
        {text: 'Conso (≥1)', value: 'total_clients'},
        {text: 'Codes', value: 'total_codes'},
        {text: 'Codes/conso', value: 'codes_per_client'},
        {text: 'Nouveaux', value: 'new_clients'},
        {text: 'Réachat', value: 'repeat_clients'},
      ],
    }
  },
  methods: {
    priceFormat(price) {
      if (price == null) {
        price = 0
      }
      return parseInt(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    getDataProduct() {
      this.isLoading1 = true
      HTTP.get("/boosting-dashboard-v2/data-product", {
        params: {
          regions: this.regions_1
        }
      }).then((res) => {
        this.isLoading1 = false
        this.data_product = res.data.data
      }).catch((err) => {
        console.log(err)
        this.isLoading1 = false
      })
    },
    getDataPos() {
      this.isLoading2 = true
      HTTP.get("/boosting-dashboard-v2/data-pos", {
        params: {
          regions: this.regions_2
        }
      }).then((res) => {
        this.isLoading2 = false
        this.data_pos = res.data.data
      }).catch((err) => {
        console.log(err)
        this.isLoading2 = false
      })
    },
    getDataConsumer() {
      this.isLoading3 = true
      HTTP.get("/boosting-dashboard-v2/data-consumer", {
        params: {
          regions: this.regions_3
        }
      }).then((res) => {
        this.isLoading3 = false
        this.data_consumer = res.data.data
      }).catch((err) => {
        console.log(err)
        this.isLoading3 = false
      })
    },
    getDataFinancial() {
      this.isLoading4 = true
      HTTP.get("/boosting-dashboard-v2/data-financial", {
        params: {
          regions: this.regions_4
        }
      }).then((res) => {
        this.isLoading4 = false
        this.data_financial = res.data.data
      }).catch((err) => {
        console.log(err)
        this.isLoading4 = false
      })
    },
  },
  created() {
    this.getDataProduct()
    this.getDataPos()
    this.getDataFinancial()
    this.getDataConsumer()
  },
  watch: {},
  computed: {
    filter_elements() {
      return this.$store.state.salepoint_filter_elements
    },
  }
}
</script>

<style>
.v-card__title {
  font-size: 1.18rem;
}
</style>